import apiFetch from '../apiFetch'

export default function (idGrupoUsuario, token) {
  return apiFetch({endPoint: `GrupoUsuario/deleteGrupoUsuario?idGrupoUsuario=` + idGrupoUsuario, method: 'GET', body: null, token: token})
}
